module.exports = __webpack_public_path__ + "img/statue.89ff42f8.jpg";